// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__21nmD","requiredAsterisk":"Info_requiredAsterisk__1bgBW"};